import { useState, useMemo, useCallback } from 'react'
export const MIN_YEAR = 1990
export const MAX_YEAR = 2100
const isYearInRange = (recordYear: number, fromYear: string, toYear: string): boolean => {
    if (!recordYear) return false

    const from = fromYear ? Number(fromYear) : null
    const to = toYear ? Number(toYear) : null

    if (from && recordYear < from) return false
    if (to && recordYear > to) return false

    return true
}
export default function InvoiceReconciliationFilters() {
    const [checkInFrom, setCheckInFrom] = useState('')
    const [checkInTo, setCheckInTo] = useState('')
    const yearError = useMemo((): string | null => {
        const hasFromInput = checkInFrom.length === 4
        const hasToInput = checkInTo.length === 4

        if (!hasFromInput && !hasToInput) return null
        if (hasFromInput && hasToInput) {
            const fromNum = Number(checkInFrom)
            const toNum = Number(checkInTo)

            if (fromNum > toNum) {
                return 'From year cannot be greater than To year'
            }
        }
        return null
    }, [checkInFrom, checkInTo])
    const handleYearChange = useCallback(
        (value: string, setter: React.Dispatch<React.SetStateAction<string>>) => {
            const cleaned = value.replace(/\D/g, '').slice(0, 4)
            setter(cleaned)
        },
        []
    )
    const isYearInvalid = !!yearError
    return {
        checkInFrom,
        checkInTo,
        yearError,
        isYearInvalid,
        setCheckInFrom,
        setCheckInTo,
        handleYearChange,
        isYearInRange,
    }
}
